export default __webpack_public_path__ + "static/media/funnel.16e221dd.png";